import {create} from "zustand/index";

interface paymentDataProps {
    paymentUrl: string;
    voucherRequestId: string;
}

interface PaymentStoreState {
    paymentData: paymentDataProps;
    setPaymentData: (paymentData: paymentDataProps) => void;
    resetPaymentData: () => void;
};

const paymentStore= create<PaymentStoreState>((set) => ({
    paymentData: {
        paymentUrl: '',
        voucherRequestId: '',
    },
    setPaymentData: (data:paymentDataProps) => set({ paymentData: {
            paymentUrl: data?.paymentUrl,
            voucherRequestId: data?.voucherRequestId,
        }}),
    resetPaymentData: () => set({paymentData : {
            paymentUrl: '',
            voucherRequestId: '',
        }})
}));

export default paymentStore;
